import gql from 'graphql-tag';

export const OBTER_CONFIGURACAO_AFILIADOS = gql`
  query obterConfiguracaoMarketingAfiliados {
    obterConfiguracaoMarketingAfiliados
  }
`;
